import React, { useState, useEffect } from "react";
import ContentLayout from "../../../../../partials/content/ContentLayout";
import * as yup from "yup";
import { Accordion, AccordionTab } from "primereact/accordion";
import Swal from "sweetalert2";
import {
  saveInvoice,
  getInvoiceDetail,
} from "../../../../../services/finance/invoice";
import InvoiceItem from "./invoiceItem";
import { PageSubHeader } from "../../../../../../provider/PageDataProvider";
import AppForm from "../../../../../partials/content/Forms/AppForm";
import InvoiceHeader from "./invoiceHeader";
import { useGlobalData } from "../../../../../../provider/GlobalDataProvider";
import store from "../../../../../store/store";
import { sendApprovalRequests, setObject } from "../../../../../utils/utils";
import { DateTime } from "luxon";
const invoiceSchema = yup.object().shape({
  ID: yup.number(),
  docRefDesc: yup.string().required("Document Reference is required"),
  invoiceType: yup.string(),
  salesOrderID: yup.number(),
  salesOrderCode: yup.string().when("deliveryID", {
    is: (value) => value === 0,
    then: yup.string().required("Sales Order ID is required"),
  }),
  deliveryID: yup.number(),
  customerID: yup.number(),
  customerName: yup.string().required("Customer Name is required"),
  invoiceDate: yup
    .date()
    .required("Invoice Date is required")
    .max(
      yup.ref("deadlineDate"),
      "Invoice Date must be less equal to Deadline Date"
    ),
  deadlineDate: yup
    .date()
    .required("Deadline Date is required")
    .min(
      yup.ref("invoiceDate"),
      "Deadline Date must be greater equal to Invoice Date"
    ),
  currencyID: yup.number(),
  currencyCode: yup.string().required("Currency is required"),
  subTotal: yup.number(),
  discountAmount: yup.number(),
  taxAmount: yup.number(),
  grandTotal: yup.number(),
  deliveryCost: yup.number(),
  cashAccountName: yup.string().required("Cash Account is required"),
  /*
  accountName: yup.string().when("deliveryCost", {
    is: (value) => value > 0,
    then: yup.string().required("Expense Account is required"),
  }),
  */
  address: yup
    .string()
    .required("Address is required")
    .max(255, "Address maximum characters is 255"),
  city: yup
    .string()
    .required("City is required")
    .max(50, "City maximum characters is 50"),
  addressPhone: yup
    .string()
    .matches(
      /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
      "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
    )
    .max(50, "Phone Number maximum characters is 50"),
  addressEmail: yup
    .string()
    .email("Email must be valid. e.g. joe@invifo.com")
    .max(50, "Email maximum characters is 50"),
  province: yup.string().max(50, "Province maximum characters is 50"),
  countryCode: yup.string(),
  postalCode: yup.string().max(10, "Postal Code maximum characters is 10"),
  contactName: yup
    .string()
    .required("Contact Name is required")
    .max(255, "Contact Name maximum characters is 255"),
  position: yup.string().max(50, "Position maximum characters is 50"),
  contactPhone: yup
    .string()
    .required("Phone Number is required")
    .matches(
      /^((\+\d{1,3}(-| )?\(?\d\)?(-| )?\d{1,3})|(\(?\d{2,6}\)?))(-| )?(\d{3,4})(-| )?(\d{4})(( x| ext)\d{1,5}){0,1}$/,
      "Phone Number must be valid. e.g. +6281XXXXXXX or 081XXXXXXX"
    )
    .max(50, "Phone Number maximum characters is 50"),
  contactEmail: yup
    .string()
    .email("Email must be valid. e.g. joe@invifo.com")
    .max(50, "Email maximum characters is 50"),
  note: yup.string(),
  toc: yup.string(),
  recStartDate: yup.date(),
  recIssueDate: yup
    .number()
    .max(31, "Date Max is 31")
    .min(1, "Date min is 1"),
  recDeadlineDate: yup
    .number()
    .max(31, "Date Max is 31")
    .min(1, "Date min is 1"),
  recEvery: yup.number(),
  periodType: yup.string(),
  billPercent: yup
    .number()
    .min(1, "Bill percentage is required")
    .required("Bill percentage is required"),
  invoiceItem: yup
    .array()
    .of(
      yup.object().shape({
        ID: yup.number(),
        salesOrderItemID: yup.number(),
        deliveryItemID: yup.number(),
        itemID: yup.number(),
        itemName: yup.string().required("Item is required"),
        varCode: yup.string(),
        qty: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .required("Quantity is required")
          .moreThan(0, "Quantity cannot be zero or empty")
          .default(0),
        uomID: yup.number(),
        uomName: yup.string().when("itemID", {
          is: (val) => val > 0,
          then: yup.string().required("Unit is required"),
        }),
        unitPrice: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .required("Unit Price is required")
          .moreThan(0, "Unit Price cannot be zero or empty")
          .default(0),
        discountPercent: yup.number().default(0),
        discountAmount: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .default(0),
        taxPercent: yup.number().default(0),
        taxAmount: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .default(0),
        totalPrice: yup
          .number()
          .transform((value) => (isNaN(value) ? 0 : value))
          .nullable()
          .required("Total Price is required")
          .default(0),
        accountName: yup.string().when("soItem", {
          is: (value) => value === false,
          then: yup.string().required("Expense Account is required"),
        }),
        soItem: yup.bool(),
        deliveryItem: yup.bool(),
      })
    )
    .required("Invoice Items is required"),
  invoiceAddCost: yup.array().of(
    yup.object().shape({
      ID: yup.number(),
      itemName: yup.string().required("Cost Name is Required"),
      accountName: yup.string().required("Account is required"),
      costPrice: yup
        .number()
        .transform((value) => (isNaN(value) ? 0 : value))
        .nullable()
        .required("Cost Price is required")
        .moreThan(0, "Cost Price cannot be zero or empty")
        .default(0),
    })
  ),
});

const InvoiceForm = ({ match, history }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const { companyProfile, socket } = useGlobalData();
  const { auth } = store.getState();
  const { fullName } = auth.user;
  const [invoice, setInvoice] = useState({
    ID: 0,
    invoiceCode: "",
    docRef: "1",
    docRefDesc: "",
    invoiceType: "1",
    giStatus: 1,
    giStatusDesc: "",
    paymentStatus: 1,
    paymentStatusDesc: "",
    salesOrderID: 0,
    salesOrderCode: "",
    deliveryID: 0,
    customerID: 0,
    cashAccountID: 0,
    cashAccountName: "",
    customerName: "",
    invoiceDate: DateTime.now().startOf("day"),
    deadlineDate: DateTime.now()
      .endOf("day")
      .plus({ days: 14 }),
    addressName: {},
    address: "",
    city: "",
    province: "",
    countryCode: companyProfile.countryCode,
    postalCode: "",
    addressPhone: "",
    addressEmail: "",
    contact: {},
    contactName: "",
    position: "",
    contactPhone: "",
    contactEmail: "",
    currencyID: companyProfile.currency.ID,
    currencyCode: companyProfile.currency.currencyCode,
    subTotal: 0,
    discountPercent: 0,
    discountAmount: 0,
    taxPercent: 0,
    taxAmount: 0,
    taxName: "",
    addCostTotal: 0,
    deliveryCost: 0,
    exchangeRate: 1,
    grandTotal: 0,
    billPercent: 0,
    billAmount: 0,
    deliveryCostAccountID: 0,
    accountName: "",
    note: "",
    tocName: {},
    toc: "",
    recStartDate: DateTime.now().startOf("day"),
    recIssueDate: 1,
    recDeadlineDate: 1,
    recEvery: 1,
    periodType: "M",
    servicesDel: false,
    invoiceItem: [],
    invoiceAddCost: [],
    CreatedAt: DateTime.now(),
    UpdatedAt: DateTime.now(),
    createdBy: 0,
    updatedBy: 0,
  });

  const invoiceID = match.params.invoiceID;
  useEffect(() => {
    const { auth } = store.getState();
    async function getInvoiceDetailData(invoiceID) {
      if (typeof invoiceID !== "undefined") {
        const invoiceItemRec = [];
        const response = await getInvoiceDetail(invoiceID);
        const { data } = response.data;
        const { invoice } = data;
        invoice.invoiceItem.forEach((item) => {
          invoiceItemRec.push({
            ID: item.ID,
            salesOrderItemID: item.salesOrderItemID,
            deliveryItemID: item.deliveryItemID,
            itemID: item.itemID,
            itemType: item.itemType,
            itemTypeName: item.itemTypeName,
            itemCode: item.itemCode,
            itemName: item.itemName,
            varCode: item.varCode,
            qty: item.qty,
            uomID: item.uomID,
            uomName: item.uom.uomName,
            unitPrice: item.unitPrice,
            taxPercent: item.taxPercent,
            taxAmount: item.taxAmount,
            taxName: item.taxName,
            discountAmountType: 1,
            discountPercent: item.discountPercent,
            discountAmount: item.discountAmount,
            totalPrice: item.totalPrice,
            unRegItem: item.ID > 0 ? false : true,
            soItem: item.salesOrderItemID > 0 ? true : false,
            deliveryItem: item.deliveryItemID > 0 ? true : false,
            deleteInd: false,
          });
        });
        setInvoice({
          ID: invoice.ID,
          invoiceCode: invoice.invoiceCode,
          docRef: invoice.docRef,
          docRefDesc:
            invoice.docRef === "1"
              ? "Sales Order"
              : invoice.docRef === "2"
              ? "Delivery"
              : null,
          giStatus: invoice.giStatus,
          giStatusDesc: invoice.giStatusDesc,
          paymentStatus: invoice.paymentStatus,
          paymentStatusDesc: invoice.paymentStatusDesc,
          invoiceType: invoice.invoiceType,
          salesOrderID: invoice.salesOrderID,
          salesOrderCode: invoice.salesOrderCode,
          deliveryID: invoice.deliveryID,
          customerID: invoice.customerID,
          cashAccountID: invoice.cashAccountID,
          cashAccountName: invoice.cashAccountName,
          customerName: invoice.customer.customerName,
          invoiceDate: invoice.invoiceDate,
          deadlineDate: invoice.deadlineDate,
          servicesDel: invoice.servicesDel,

          address: invoice.address,
          city: invoice.city,
          province: invoice.province,
          countryCode: invoice.countryCode,
          postalCode: invoice.postalCode,
          addressPhone: invoice.addressPhone,
          addressEmail: invoice.addressEmail,

          contactName: invoice.contactName,
          position: invoice.position,
          contactPhone: invoice.contactPhone,
          contactEmail: invoice.contactEmail,

          currencyID: invoice.currencyID,
          currencyCode: invoice.currency.currencyCode,
          billPercent: invoice.billPercent,
          billAmount: invoice.billAmount,
          subTotal: invoice.subTotal,
          discountPercent: invoice.discountPercent,
          discountAmount: invoice.discountAmount,
          taxPercent: invoice.taxPercent,
          taxAmount: invoice.taxAmount,
          taxName: invoice.taxName,
          addCostTotal: invoice.addCostTotal,
          deliveryCost: invoice.deliveryCost,
          exchangeRate: invoice.exchangeRate,
          grandTotal: invoice.grandTotal,
          note: invoice.note,
          toc: invoice.toc,
          recStartDate: invoice.recStartDate,
          recIssueDate: invoice.recIssueDate,
          recDeadlineDate: invoice.recDeadlineDate,
          recEvery: invoice.recEvery,
          periodType: invoice.periodType,
          invoiceItem: invoiceItemRec,
          invoiceAddCost: invoice.invoiceAddCost,
          CreatedAt: invoice.CreatedAt,
          UpdatedAt: invoice.UpdatedAt,
          createdBy: invoice.createdBy,
          updatedBy: invoice.updatedBy,
        });
      }
    }

    if (invoiceID > 0) {
      setObject(socket, "lock", invoiceID, "INVO", auth.user)
        .then((response) => {
          getInvoiceDetailData(invoiceID);
        })
        .catch((error) => {
          history.push("/finance/invoices/AR");
        });
    }
    return () => {
      if (invoiceID > 0) {
        setObject(socket, "release", invoiceID, "INVO", auth.user);
      }
    };
  }, [invoiceID]);

  return (
    <React.Fragment>
      <PageSubHeader
        title="Account Receivable Invoice Form"
        breadcrumbs={[
          { page: "/menu", title: "Menu", active: false },
          {
            page: "/finance/invoices/AR",
            title: "A/R Invoices",
            active: false,
          },
          {
            page: "/finance/create-invoice",
            title: "A/R Invoice Form",
            active: true,
          },
        ]}
        actionButtons={[
          {
            title: "",
            color: "label-brand",
            icon: "fas fa-backward",
            onClick: () => {
              history.push("/finance/invoices/AR");
            },
          },
        ]}
      />
      <AppForm
        initialValues={invoice}
        validationSchema={invoiceSchema}
        headSubmitButton
        onSubmit={(values, { resetForm, setStatus, setSubmitting }) => {
          values.subTotal = parseFloat(values.subTotal);
          values.discountPercent = parseFloat(values.discountPercent);
          values.discountAmount = parseFloat(values.discountAmount);
          values.taxPercent = parseFloat(values.taxPercent);
          values.taxAmount = parseFloat(values.taxAmount);
          values.grandTotal = parseFloat(values.grandTotal);
          values.billPercent = parseFloat(values.billPercent);
          values.billAmount = parseFloat(values.billAmount);
          values.invoiceItem.map((item) => {
            item.unitPrice = parseFloat(item.unitPrice);
            item.taxPercent = parseFloat(item.taxPercent);
            item.taxAmount = parseFloat(item.taxAmount);
            item.discountPercent = parseFloat(item.discountPercent);
            item.discountAmount = parseFloat(item.discountAmount);
            item.totalPrice = parseFloat(item.totalPrice);
          });
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          })
            .fire({
              title:
                "Are you sure want to save this Account Receivable Invoice ?",
              text: "Please note that you are responsible for this action",
              icon: "question",
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, save it`,
              cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
              reverseButtons: true,
            })
            .then((result) => {
              if (result.isConfirmed) {
                saveInvoice(values).then((response) => {
                  Swal.mixin({
                    customClass: {
                      confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                    },
                    buttonsStyling: false,
                  }).fire({
                    title: "Saved",
                    html: response.data.message,
                    icon: "success",
                    showCloseButton: true,
                    confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                  });

                  let toUsers = [];
                  const { data } = response.data;

                  if (
                    data.notificationToUsers &&
                    data.notificationToUsers.length > 0
                  ) {
                    data.notificationToUsers.map(
                      (notificationToUser, index) => {
                        toUsers.push({
                          ID: notificationToUser.toUserID,
                        });
                      }
                    );
                  }

                  if (toUsers && toUsers.length > 0) {
                    sendApprovalRequests(socket, fullName, toUsers);
                  }

                  history.push("/finance/invoices/AR");
                });
              } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.mixin({
                  customClass: {
                    confirmButton: "btn btn-success btn-md btn-pill btn-bold",
                  },
                  buttonsStyling: false,
                }).fire({
                  title: "Cancelled",
                  text: "No change has been made",
                  icon: "info",
                  showCloseButton: true,
                  confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
                });
              }
            });
        }}
      >
        <ContentLayout>
          <InvoiceHeader />
          <div className="accordion">
            <div className="card">
              <Accordion
                className="accordion"
                activeIndex={activeIndex}
                onTabChange={(e) => setActiveIndex(e.index)}
              >
                <AccordionTab
                  header={
                    <React.Fragment>
                      <i className="fas fa-sitemap"></i>
                      <span>
                        <strong>Account Receivable Invoice Items</strong>
                      </span>
                    </React.Fragment>
                  }
                >
                  <div className="row">
                    <div className="col-sm-12 col-md-12 col-lg-12">
                      <InvoiceItem property="invoiceItem" />
                    </div>
                  </div>
                </AccordionTab>
              </Accordion>
            </div>
          </div>
        </ContentLayout>
      </AppForm>
    </React.Fragment>
  );
};

export default InvoiceForm;
